import { createSlice } from '@reduxjs/toolkit';
import { UploadFormManagementState } from 'pages/UploadManagement/types';

export const initialState: UploadFormManagementState = {
  list: [],
  uploadFormLoading: false,
  loading: false,
  error: '',
  tagList: [],
  tagCategoryList: [],
  content: {},
  revisions: []
};

const localeSlice = createSlice({
  name: 'uploadFormManagement',
  initialState,
  reducers: {
    fetchConversionList: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchConversionListSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    fetchConversionListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getTagsByMarketer: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getTagsByMarketerSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.tagList = action.payload;
    },
    getTagsByMarketerFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    addTagCategory: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    addTagCategorySuccess: state => {
      state.loading = false;
      state.error = '';
    },
    addTagCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getTagCategoriesByMarketer: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getTagCategoriesByMarketerSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.tagCategoryList = action.payload;
    },
    getTagCategoriesByMarketerFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    deleteTag: (state, action) => {
      // state.loading = true;
      state.error = '';
    },
    deleteTagSuccess: state => {
      // state.loading = false;
      state.error = '';
    },
    deleteTagFailure: (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    },
    updateTagCategory: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateTagCategorySuccess: state => {
      state.loading = false;
      state.error = '';
    },
    updateTagCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setLoadingTrue: state => {
      state.loading = true;
    },
    setLoadingFalse: state => {
      state.loading = false;
    },
    deleteCategory: (state, action) => {
      // state.loading = true;
      state.error = '';
    },
    deleteCategorySuccess: state => {
      // state.loading = false;
      state.error = '';
    },
    deleteCategoryFailure: (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    },
    fetchContent: (state, action) => {
      state.uploadFormLoading = true;
      state.error = '';
    },
    fetchContentSuccess: (state, action) => {
      state.uploadFormLoading = false;
      state.content = action.payload;
    },
    fetchContentFailure: (state, action) => {
      state.uploadFormLoading = false;
      state.error = action.payload;
    },
    clearContentState: (state, action) => {
      state.loading = false;
      state.content = {};
    },
    fetchRevisionDetails: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchRevisionDetailsSuccess: (state, action) => {
      state.loading = false;
      state.content = action.payload;
      state.revisions = action.payload;
    },
    fetchRevisionDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  fetchConversionList,
  fetchConversionListSuccess,
  fetchConversionListFailure,
  getTagsByMarketer,
  getTagsByMarketerSuccess,
  getTagsByMarketerFailure,
  addTagCategory,
  addTagCategorySuccess,
  addTagCategoryFailure,
  getTagCategoriesByMarketer,
  getTagCategoriesByMarketerSuccess,
  getTagCategoriesByMarketerFailure,
  deleteTag,
  deleteTagSuccess,
  deleteTagFailure,
  updateTagCategory,
  updateTagCategorySuccess,
  updateTagCategoryFailure,
  setLoadingTrue,
  setLoadingFalse,
  deleteCategory,
  deleteCategorySuccess,
  deleteCategoryFailure,
  fetchContent,
  fetchContentSuccess,
  fetchContentFailure,
  clearContentState,
  fetchRevisionDetails,
  fetchRevisionDetailsSuccess,
  fetchRevisionDetailsFailure,
  resetState
} = localeSlice.actions;

export default localeSlice.reducer;
